import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/Home/HomeView.vue'
import HomeTimeBasedGanttChart from "@/views/Home/HomeTimeBasedGanttChart.vue";
import GanttChartDemo from '../views/GanttChartDemo.vue'
import GanttChartTime from "@/views/GanttChartTime.vue";
import GanttChartOriginal from "@/views/Home/GanttChartOriginal.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/gantt-chart-by-time/:targetDate',
    name: 'HomeTimeBasedGanttChart',
    component: HomeTimeBasedGanttChart
  },
  {
    path: '/gantt-chart-demo',
    name: 'GanttChartView',
    component: GanttChartDemo
  },
  {
    path: '/gantt-chart-time',
    name: 'GanttChartTime',
    component: GanttChartTime
  },
  {
    path: '/gantt-chart-original',
    name: 'GanttChartOriginal',
    component: GanttChartOriginal
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
